import en from './en.json';
import nl from './nl.json';

export default {
  en,
  nl,
};



// WEBPACK FOOTER //
// ./src/i18n/messages/index.js